"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyProvider = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const TypographyProvider = styled_components_1.default.span `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap');

  @font-face {
    font-family: 'Montserrat';
    font-display: swap;
  }

  font-family: 'Montserrat', sans-serif;

  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  line-height: 1;
  width: auto;
`;
exports.TypographyProvider = TypographyProvider;
//# sourceMappingURL=TypographyProvider.js.map